<template>
  <v-content>
    <v-row wrap class="layout">
      <v-col cols="12">
        <h1 class="display-1">
          {{ $t("IMPRINT_HEADER") }}
        </h1>
      </v-col>
      <v-col cols="12" class="imprintContent">
        <div v-html="$t('IMPRINT_TEXT')"></div>
      </v-col>
    </v-row>
  </v-content>

</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";

@Component({
  components: {}
})
export default class Imprint extends BasicComponent {

  created() {

  }

  mounted() {
    this.trackPage("Impressum");
  }
}

</script>
<style lang="scss" scoped>

.layout {
  margin-top: 10px;
}

.imprintContent {
  margin-top: 25px;
}

</style>
<style lang="scss">

</style>
